import { CustomerManagementGridItem } from 'shared/types/customerManagement';
import { Column } from 'react-table';
import { NumberColumn, TextColumn } from 'shared/tables/columns';
import { LinkColumn } from './customer-name-link-column';
import { SelectColumnFilter } from '../filters/select-column-filter';
import { ActionColumn } from './customer-management-action-column';
import { ShowDeletedFilter } from '../filters/show-deleted-filter';
import { StatusColumn } from './customer-management-status-column';

export const customerManagementTableColumns: Column<CustomerManagementGridItem>[] = [
  {
    Header: 'Actions',
    accessor: 'isDeleted',
    Cell: ActionColumn,
    align: 'left',
    filterOrder: 9,
    disableFilters: false,
    Filter: ShowDeletedFilter,
  },
  {
    Header: 'Status',
    accessor: 'isMarkedForDeletion',
    Cell: StatusColumn,
    align: 'left',
    filterOrder: 9,
    disableFilters: true,
  },
  {
    Header: 'ABG Brand',
    accessor: 'abgBrand',
    Cell: LinkColumn,
    align: 'left',
    Filter: SelectColumnFilter,
    disableFilters: false,
    filterOrder: 1,
  },
  {
    Header: 'Tier',
    accessor: 'customerTier',
    Cell: TextColumn,
    align: 'left',
    Filter: SelectColumnFilter,
    disableFilters: false,
    filterOrder: 2,
  },
  {
    Header: 'Master Customer',
    accessor: 'masterCustomer',
    Cell: TextColumn,
    align: 'left',
    Filter: SelectColumnFilter,
    disableFilters: false,
    filterOrder: 3,
  },
  {
    Header: 'Channel',
    accessor: 'channel',
    Cell: TextColumn,
    align: 'left',
    Filter: SelectColumnFilter,
    disableFilters: false,
    filterOrder: 4,
  },
  {
    Header: '# of Contracts',
    accessor: 'numberOfContracts',
    Cell: NumberColumn,
    align: 'left',
    filterOrder: 5,
  },
];

export const hiddenCustomerManagementTableColumns = customerManagementTableColumns.reduce<string[]>(
  (hiddenColumns, column) => {
    if (column.hidden) {
      hiddenColumns.push(String(column.accessor));
    }
    return hiddenColumns;
  },
  []
);
